<script>
    import Button from '../components/Button.svelte'
</script>

<style type="text/scss">ul {
  padding-left: 30px;
}

.model {
  margin-bottom: 1rem;
}

.step {
  margin-bottom: 1.5rem;
}
/*# sourceMappingURL=src/sections/Colabora.svelte.map */</style>

<div class="wrapper bg-accent-light py-10">
    <div class="container py-10">
        <div class="content w-full">
            <h1>Colabora en 3 simples pasos</h1>
            <div class="step">
                <h2>1. Descarga uno de los modelos 3D</h2>
                <div class="model wrapper flex col-12 justify-between flex-wrap">
                    <div class="model flex flex-col w-full md:tablet-col-6 lg:col-6">
                        <p class="font-bold ">Modelo simple:</p>
                        <ul class="list-disc">
                            <li>
                                <span class="font-bold">Unidades:</span>
                                1 pantalla protectora por impresión.
                            </li>
                            <li>
                                <span class="font-bold">Compatibilidad:</span>
                                cama {'<'} 220mm x 220mm.
                            </li>
                            <li>
                                <span class="font-bold">Tiempo de impresión:</span>
                                ~3h.
                            </li>
                        </ul>
                        <Button title="Descargar" url="covid19_headband_rc1.stl" type="download" openNewTab={true} />
                    </div>
                    <div class="model flex flex-col w-full md:tablet-col-6 lg:col-6">
                        <p class="font-bold ">Modelo doble:</p>
                        <ul class="list-disc">
                            <li>
                                <span class="font-bold">Unidades:</span>
                                2 pantallas protectoras por impresión.
                            </li>
                            <li>
                                <span class="font-bold">Compatibilidad:</span>
                                cama {'>='} 220mm x 220mm.
                            </li>
                            <li>
                                <span class="font-bold">Tiempo de impresión:</span>
                                ~6h.
                            </li>
                        </ul>
                        <Button title="Descargar" url="covid19_headband_rc1_doble.stl" type="download" openNewTab={true} />
                    </div>
                </div>
            </div>
            <div class="step">
                <h2>2. Imprime el modelo</h2>
                <p class="font-bold ">Recomendaciones:</p>
                <ul class="list-disc">
                    <li>
                        <span class="font-bold">Plástico:</span>
                        PLA/PET.
                    </li>
                    <li>
                        <span class="font-bold">Altura de capa:</span>
                        0.28mm.
                    </li>
                    <li>
                        <span class="font-bold">Tamaño de boquilla:</span>
                        0.4mm.
                    </li>
                </ul>
            </div>
            <div class="step">
                <h2>3. Mándanos tus piezas impresas</h2>
                <p class="">
                    Cuando tengas el modelo impreso (o preferiblemente varios), envíanos tus piezas a la siguiente dirección:
                </p>
                <p class="font-bold">
                    Boxfish Studio - Calle de Méjico 11, bajo derecha 4D. 28028 Madrid.
                    <a target="_blank" href="https://goo.gl/maps/48YDxoXWg1Ah5yYs5">Google Maps</a>
                </p>
                <p>
                    Agradeceríamos si nos avisas del envio a través del mail
                    <a href="mailto:covid19@boxfish.studio">covid19@boxfish.studio</a>
                    para poder organizar nuestro stock con la mayor anticipación. Nosotros nos encargamos del resto.
                </p>
                <ul class="list-disc">
                    <li>Ensamblaje final PVC + goma de sujeción.</li>
                    <li>Esterilización.</li>
                    <li>Distribución a los hospitales de Madrid.</li>
                </ul>
            </div>
        </div>
    </div>
</div>
